import React, { useCallback, useEffect, useState } from "react";
import "../Home/Home.scss";
import searchIconIMG from "../../assets/images/megnificant-glass.png";
import Location from "../../components/Map/Location";
import AddDevice from "../../components/AddDevice/AddDevice";
import CommonTable from "../../components/Table/CommonTable";
import ExternalShareurl from "../../components/ExternalCard/ExternalShareurl";
import DeviceControlBar from "../../components/DeviceControlBar/DeviceControlBar";
import useApi from "../../hook/useAPI";
import { DEVICE, ZONES } from "../../utils/const";
import { useContextValue } from "../../context/LoaderContext";
import { debounce } from 'lodash';
import dayjs from "dayjs";
import { AUTH } from "../../utils/const";
import { use } from "react";
import { convert } from "../../utils/moment";
import socketFunc from "../../utils/socket";
import {
  mergeDeviceStatusFromSocket,
  mergeSocketIntoDeviceArray,
  useDeviceStatusSocketUpdater,
} from "../../hook/useDeviceStatusSocket";
import { findDeviceInList, getDeviceRagView, mergeDeviceRagFields } from "../../utils/deviceRagDisplay";
const Home = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [deviceData, setDeviceData] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [deviceDetails, setDeviceDetails] = useState()
  const { setDevice, device } = useContextValue();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [rowData, setRowData] = useState([]);
  const [zoneList, setZoneList] = useState();
  const [DevicesList, setDevicesList] = useState();
  const [center, setCenter] = useState({ lat: 33.5779, lng: -101.8552 });
  const [sortBy, setSortBy] = useState("");
  const [sortType, setSortType] = useState("");
  const [data, setData] = useState([]);
  const deviceStoredData = JSON.parse(localStorage.getItem('deviceData')) || null;
  const once_expires_in = localStorage.getItem('1nce_expires_in')
  let devicesList = [];
  const openDeviceDetail = (item) => {
    setIsOpen(true);
    const locationRow = findDeviceInList(item, DevicesList);
    setDeviceDetails(mergeDeviceRagFields(item, locationRow));
    setSearchTerm(item.name);
    setDevice(item.name);
  };


  useEffect(() => {
    if (!isOpen) {
      setDevice("")
    }
  }, [isOpen])

  useEffect(() => {
    if (device === "") {
      setIsOpen(false)
    }
  }, [device])
  const { getData } = useApi();

  const onceAuthentication = async () => {
    // const res = await getData(`${AUTH?.ONCE_AUTHENTICATE}`);
    //     localStorage.setItem('1nce_access_token', res?.access_token);
    //     localStorage.setItem("1nce_expires_in" , res?.expires_in)
  }

  useEffect(() => {
    const intervalMs = Number(once_expires_in) * 1000;
    if (!Number.isFinite(intervalMs) || intervalMs <= 0) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      onceAuthentication();
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [once_expires_in]);

  const columnsOptions = [
    { header: "Device", key: 'device' },
    { header: "Status", key: 'status', },
    { header: "Location", key: 'location', },
    { header: "Command", key: 'command', },
    { header: "Battery", key: 'battery', },
    { header: "Date / Time", key: 'date' }
  ]


  const fetchZone = async () => {
    try {
      const response = await getData(`${ZONES?.GET_ALL_ZONES}/?page=${1}&limit=${10}`);

      if (response?.status == 200 && response?.data.length > 0) {
        setZoneList(response?.data)
      } else {
        setZoneList()
        console.log('Failed to fetch zone details.');
      }
    } catch (err) {
      setZoneList()
      console.error("Error fetching zone details:", err);
    }

    try {
      const response = await getData(`${DEVICE?.GET_DEVICE_LOCATIONS_v2}/?page=${1}&limit=${10}`);
      if (response?.status == 200 && response?.data?.length > 0) {
        setDevicesList(response?.data);
        devicesList = response?.data;

        // if (deviceStoredData !== null) {
        if (response?.data.length > 0) {
          setCenter({
            lat: Number(response?.data[0].latitude),
            lng: Number(response?.data[0].longitude)
          });
        }


      }

      // } else {

      //   console.log('Failed to fetch device details.');
      // }
    } catch (err) {

      console.error("Error fetching device details:", err);
    }

  };
  const updateMapFromSocket = useDeviceStatusSocketUpdater(setDevicesList);

  const handleDeviceSocketUpdate = useCallback(
    (payload) => {
      updateMapFromSocket(payload);
      setData((prev) => mergeSocketIntoDeviceArray(prev, payload));
      setDeviceData((prev) => mergeSocketIntoDeviceArray(prev, payload));
      setDeviceDetails((prev) => {
        if (!prev) {
          return prev;
        }
        const merged = mergeDeviceStatusFromSocket(prev, payload);
        return merged !== prev ? merged : prev;
      });
    },
    [updateMapFromSocket],
  );

  useEffect(() => {
    if (data.length > 0) {
      fetchZone();
      socketFunc(data, null, handleDeviceSocketUpdate);
    }
  }, [data, handleDeviceSocketUpdate]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     fetchZone();
  //   }, 60000);

  //   return () => clearInterval(intervalId);
  // }, [])
  const GetCurrentDeviceStatus = useCallback(debounce(async (query) => {
    try {
      const safeSearch = (searchTerm || query || "").trim();
      const response = await getData(
        `${DEVICE?.GET_DEVICE_STATUS}?page=${currentPage}&limit=${itemsPerPage}&search=${encodeURIComponent(safeSearch)}`, null, false
        // `${DEVICE?.GET_LIVE_DEVICE_STATUS}?page=${currentPage}&limit=${itemsPerPage}&search=${query}`
      );
      if (response?.status == 200 && response?.data.length > 0) {

        setDeviceData(response?.data)
        setTotalPages(response.totalPages || 1);
        setCurrentPage(Number(response.currentPage) || 1);
      }
      else {
        setDeviceData([]);
      }
    } catch (error) {
      console.error("Error fetching device details:", error);
      setDeviceData([]);
    }
  }, 500), [itemsPerPage, currentPage, searchTerm]);

  useEffect(() => {
    GetCurrentDeviceStatus(searchTerm)
    return () => GetCurrentDeviceStatus.cancel()
  }, [searchTerm, currentPage, itemsPerPage, GetCurrentDeviceStatus])


  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     GetCurrentDeviceStatus(searchTerm);
  //   }, 60000);

  //   return () => clearInterval(intervalId);
  // }, [GetCurrentDeviceStatus, searchTerm]);
  const SearchCurrentData = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setCurrentPage(1);
  }
  const getAddress = (latitude, longitude) => {
    return new Promise((resolve, reject) => {
      if (latitude && longitude && window.google) {
        const geocoder = new window.google.maps.Geocoder();
        const location = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

        geocoder.geocode({ location }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].formatted_address);  // Return the formatted address
          } else {
            console.error("Geocoder failed due to: " + status);
            resolve("-");  // Return a default value in case of failure
          }
        });
      } else {
        resolve("-");
      }
    });
  };



  const mapDeviceData = async () => {
    const mappedData = await Promise.all(deviceData.map(async (item) => {
      return ({
        device: item?.deviceName || "-",
        deviceCategory: item?.deviceCategory || "smartphone",
        status: getDeviceRagView(item).label || "-",
        location: item?.address || "-",
        command: item?.command || "-",
        battery: item?.batteryLevel || "-",
        // date: item?.dateTime || "-",
        date: item?.dateTime ? convert(item.dateTime, 'DD MMM YYYY HH:mm:ss') : "-",
      })
    }
    ));

    return mappedData;
  };

  useEffect(() => {
    const fetchRowData = async () => {
      const data = await mapDeviceData();
      setRowData(data);
    };
    fetchRowData();
  }, [deviceData]);


  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="dashboard">
        <div className="row">
          <div className="col-lg-7 col-xl-8">
            <div className="card map-height">
              <div className="card-body p-0">
                <Location zoneData={zoneList} DevicesList={DevicesList} center={center} setCenter={setCenter} />
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-xl-4 ">
            {isOpen ? (
              <>
                <ExternalShareurl setSearchTerm={setSearchTerm} deviceDetails={deviceDetails} devicesList={DevicesList} />
                <DeviceControlBar deviceDetails={deviceDetails} devicesList={DevicesList} setCenter={setCenter} />
              </>
            ) : (
              <div className="card">
                <div className="card-body">
                  <AddDevice
                    setData={setData}
                    devices={data}
                    handleMenu={openDeviceDetail}
                    AddDeviceData={GetCurrentDeviceStatus}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* common table card start  */}
        <div className="card">
          <div className="card-body p-0 ">
            <div className="home-table-chart-box">
              <div className="top_bar">
                <div className="card_title">Current Status</div>
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">
                    <img
                      src={searchIconIMG}
                      className="ing-fluid"
                      alt="search-icon"
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search or type a command"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={(e) => SearchCurrentData(e)}
                  />
                </div>
              </div>

              {/* <CommonTable columns={columnsOptions} rows={rowData} scroll /> */}
              <CommonTable
                columns={columnsOptions}
                rows={rowData}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                currentPage={currentPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
                isPagination
                sortBy={sortBy}
                setSortBy={setSortBy}
                setSortType={setSortType}
              />
            </div>
          </div>
        </div>
      </div>
      {/* common table card end  */}
    </>
  );
};

export default Home;
